// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"10":"04442852","69":"612fc3d2","787":"4876da1b"}[chunkId] + ".chunk.css";
};